import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
  selector: 'ag-grid-slide-view',
  templateUrl: 'ag-grid-slide-view.html'
})
export class AgGridSlideViewComponent implements ICellRendererAngularComp {
  public params: any = {};
  cellValue: any;
  value: any = {};

  agInit(params: any): void {
    this.cellValue = params;
  }

  onClick(e) {
   
    if (this.cellValue.onClick instanceof Function) {
      const params = {
        event: e,
        rowData: this.cellValue.node.data,
        type: 'update',
        rowIndex: this.cellValue.rowIndex
      }
      this.cellValue.onClick(params);
    }
  }

  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/agGridRenderer/ag-grid-slide-view/ag-grid-slide-view.ts